import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { client } from '../../../../gql/client';
import { GET_BUDGET_CATEGORIES } from '../../../../gql/queries/budget/budgetCategories';

// Utils
import { AuthContextType } from '../../../../hooks/useAuth';

// Constants
import { formBudgetCategoryManagementNaming } from '../../../../components/forms/AddBudgetCategoryForm/constants';
import { decompressSessionStorage } from '../../../../utils/sessionStorage';

const loadTableData = async (userData: AuthContextType | null) => {
  try {
    if (userData?.user) {
      const {
        data: { budgetCategories },
      } = await client.query({
        query: GET_BUDGET_CATEGORIES,
        fetchPolicy: 'network-only',
        variables: {
          filters: null,
          pagination: { page: 1, limit: 10000 },
        },
      });

      // Ordenar por código
      const sortedCategories = [...budgetCategories].sort((a, b) =>
        a.code.localeCompare(b.code)
      );

      return sortedCategories.map((category) => ({
        id: category.id,
        code: category.code,
        name: category.name,
        color: category.color,
        budgetItemsCount: category.budgetItemsCount || 0,
        state: 'active',
        createdAt: category.createdAt,
        updatedAt: category.updatedAt,
      }));
    }

    return [];
  } catch (err) {
    Sentry.captureException(err);
    return [];
  }
};

export const BudgetCategoriesManagementLoader: (
  userData: AuthContextType | null
) => LoaderFunction | undefined = (userData) => async () => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  const data = await loadTableData(userData);

  const activeCategories = data;
  const inactiveCategories: any[] = [];

  let cacheData =
    sessionStorage.getItem(
      formBudgetCategoryManagementNaming.NEW_BUDGET_CATEGORY_MANAGEMENT_FORM
    ) || {};

  if (Object.keys(cacheData).length > 0) {
    cacheData = JSON.parse(decompressSessionStorage(cacheData as string));
  }

  return {
      activeCategories,
      inactiveCategories,
      cacheData: {
        ...cacheData,
      },
    };
};

  return { data: load() };
};
